import { render } from "./copyWorkflow.vue?vue&type=template&id=48db299a&ts=true"
import script from "./copyWorkflow.vue?vue&type=script&lang=ts"
export * from "./copyWorkflow.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\BuildAgent\\work\\2f08168a1cda37d3\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__